import { Component, Input, OnInit } from '@angular/core';
import { LocalLoadEvent } from '../../../shared/local-load-event.model';

@Component({
  selector: 'app-load-event-status-update',
  templateUrl: './load-event-status-update.component.html',
  styleUrls: ['./load-event-status-update.component.scss']
})
export class LoadEventStatusUpdateComponent implements OnInit {

  @Input()
  event: LocalLoadEvent;

  constructor() {
  }

  ngOnInit() {
  }

}
